export const getFilters = s => s.caseStudy.get('filters')?.toJS();
export const getCaseStudy = s => s.caseStudy.get('caseStudy').toJS();
export const getCaseStudyLoading = s => s.caseStudy.get('caseStudyLoading');
